const ConsumeContent = {
  props: {
    data: {
      type: Object,
      required: true
    },
    pageType: {
      type: String
    },
    renderContent: {
      type: Function,
      required: true
    },
    vm: {
      default: this.$parent
    }
  },
  render (h) {
    return this.renderContent(h, this.pageType, this.data, this.vm)
  }
}

export {
  ConsumeContent
}

export default ConsumeContent



// WEBPACK FOOTER //
// ./src/components/common/di-ding/common/consume-content.js